// inputs.js
import { validateRequired,validateLength, validateNonZeroInteger,validateNotNull }from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Codigo",
    name: "codigo_rubro",
    type: "text",
    placeholder: "Ingrese el codigo",
      validation: (value, form) => {
          // Validación requerida
          const requiredError = validateNotNull(value);
          if (requiredError) {
            return requiredError;
          }
              // Si no hay errores
          return null;
        }
  },
  {
    id: 2,
    label: "Descripcion",
    name: "descripcion_rubro",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "Ramo",
    name: "ramo_Id",
    type: "select", // Cambiado a "select"
    options: [],
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }
      // Si no hay errores
      return null;
    }
  },
  // Agrega más campos aquí
];

export default Inputs;
